import './index.scss';

import { Component, MouseEvent, ReactNode, Ref } from 'react';

import { BraxSize, BraxThemeVariant } from '../../types';

export type BraxButtonVariant = Extract<BraxThemeVariant, 'primary' | 'secondary' | 'success' | 'destructive' | 'light'> | 'tertiary' | 'quaternary' | 'warning';

export type BraxButtonProps = {
    innerRef?: Ref<HTMLButtonElement>,
    type: 'button' | 'submit' | 'reset',
    variant: BraxButtonVariant,
    size: BraxSize,
    className?: string,
    title?: string,
    disabled: boolean,
    children: ReactNode,
    onClick?: (event: MouseEvent<HTMLButtonElement>) => void
};

export class BraxButton extends Component<BraxButtonProps> {

    static defaultProps = {
        variant: 'primary',
        size: 'lg',
        type: 'button',
        disabled: false
    };

    render() {
        const { innerRef, variant, size, className, ...props } = this.props;

        return (
            <button
                ref={innerRef}
                className={`brax-button ${variant} ${size} ${className || ''}`}
                {...props}
            >
                { this.props.children }
            </button>
        );
    }

}
